import { render, staticRenderFns } from "./GlossaryChapter.vue?vue&type=template&id=1e4794c8&scoped=true&"
import script from "./GlossaryChapter.vue?vue&type=script&lang=ts&"
export * from "./GlossaryChapter.vue?vue&type=script&lang=ts&"
import style0 from "./GlossaryChapter.vue?vue&type=style&index=0&id=1e4794c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4794c8",
  null
  
)

export default component.exports